import { render, staticRenderFns } from "./BarChartVert.vue?vue&type=template&id=2df5bb49&scoped=true&"
import script from "./BarChartVert.vue?vue&type=script&lang=js&"
export * from "./BarChartVert.vue?vue&type=script&lang=js&"
import style0 from "./BarChartVert.vue?vue&type=style&index=0&id=2df5bb49&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2df5bb49",
  null
  
)

export default component.exports